const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const requestId = urlParams.get('rid');
const orderId = urlParams.get('orderid');
export default [
    //new route
    {
      path: '/dashboard',
      name: 'home-dashboard',
      component: () => import('@/views/dashboard-new/dashboard.vue'),
      meta: {
        pageTitle: 'หน้าหลัก',
        contentClass: 'ecommerce-application',
        breadcrumb: [
          {
            text: 'หน้าหลัก',
            active: true,
          },
        ],
        resource: 'normal',
        action: 'manage',
      },
    },
    {
      path: '/import/formal',
      name: 'formal-import',
      component: () => import('@/views/customer-shipping/import/formal-import.vue'),
      meta: {
        pageTitle: 'นำเข้าแบบถูกต้อง',
        contentClass: 'ecommerce-application',
        breadcrumb: [
          {
            text: 'นำเข้าแบบถูกต้อง',
            active: true,
          },
        ],
        resource: 'normal',
        action: 'manage',
      },
    },
    {
      path: '/import/formal/action',
      name: 'formal-import-action',
      component: () => import('@/views/customer-shipping/import/action-list.vue'),
      meta: {
        pageTitle: 'สร้าง/แก้ไขรายการนำเข้า',
        contentClass: 'ecommerce-application',
        breadcrumb: [
          {
            text: 'นำเข้าแบบถูกต้อง',
            active: false,
            to: 'formal-import'
          },
          {
            text: 'สร้าง/แก้ไขรายการนำเข้า',
            active: true,
          },
        ],
        resource: 'normal',
        action: 'manage',
      },
    },
    {
      path: '/import/formal/information',
      name: 'formal-import-info',
      component: () => import('@/views/customer-shipping/import/view-info.vue'),
      meta: {
        pageTitle: 'รายละเอียดนำเข้าแบบถูกต้อง',
        contentClass: 'ecommerce-application',
        breadcrumb: [
          {
            text: 'นำเข้าแบบถูกต้อง',
            active: false,
            to: 'formal-import'
          },
          {
            text: 'รายละเอียดนำเข้าแบบถูกต้อง',
            active: true,
          },
        ],
        resource: 'normal',
        action: 'manage',
      },
    },
    // ลูกค้าใบสั่งซื้อ
    // {
    //   path: '/customer-orders/order',
    //   name: 'customer-orders-order',
    //   component: () => import('@/views/customer-orders/order/order.vue'),
    //   meta: {
    //     pageTitle: 'สั่งสินค้า',
    //     contentClass: 'ecommerce-application',
    //     breadcrumb: [
    //       {
    //         text: 'สั่งสินค้า',
    //         active: true,
    //       },
    //     ],
    //     resource: 'normal',
    //     action: 'manage',
    //   },
    // },
    // {
    //   path: '/customer-orders/cart',
    //   name: 'customer-orders-cart',
    //   component: () => import('@/views/customer-orders/cart/ECommerceCheckout.vue'),
    //   meta: {
    //     pageTitle: 'ตะกร้าของฉัน',
    //     contentClass: 'ecommerce-application',
    //     breadcrumb: [
    //       {
    //         text: 'ตะกร้าของฉัน',
    //         active: true,
    //       },
    //     ],
    //     resource: 'normal',
    //     action: 'manage',
    //   },
    // },
    {
      path: '/customer-orders/confirm',
      name: 'customer-orders-confirm',
      component: () => import('@/views/customer-orders/cart/ECommerceCheckoutStepAddress.vue'),
      meta: {
        pageTitle: 'สั่งสินค้า',
        contentClass: 'ecommerce-application',
        breadcrumb: [
          {
            text: 'สั่งสินค้า',
            active: true,
          },
        ],
        resource: 'normal',
        action: 'manage',
      },
    },
    // {
    //   path: '/customer-orders/detail',
    //   name: 'customer-orders-detail',
    //   component: () => import('@/views/customer-orders/detail/all-order.vue'),
    //   meta: {
    //     pageTitle: 'รายละเอียดการสั่งซื้อสินค้า',
    //     contentClass: 'ecommerce-application',
    //     breadcrumb: [
    //       {
    //         text: 'รายละเอียดการสั่งซื้อสินค้า',
    //         active: true,
    //       },
    //     ],
    //     resource: 'normal',
    //     action: 'manage',
    //   },
    // },
    // {
    //   path: '/customer-orders/order-detail',
    //   name: 'customer-orders-order-detail',
    //   component: () => import('@/views/customer-orders/detail/order-detail-new.vue'),
    //   meta: {
    //     pageTitle: 'รายละเอียดออเดอร์',
    //     contentClass: 'ecommerce-application',
    //     breadcrumb: [
    //       {
    //         text: 'รายละเอียดออเดอร์',
    //         active: false,
    //         to: 'customer-orders-detail',
    //       },
    //       {
    //         text: orderId,
    //         active: true,
    //       },
    //     ],
    //     resource: 'normal',
    //     action: 'manage',
    //   },
    // },
    // {
    //   path: '/customer-orders/edit-order',
    //   name: 'customer-orders-edit-order',
    //   component: () => import('@/views/customer-orders/detail/edit-order.vue'),
    //   meta: {
    //     pageTitle: 'Detail',
    //     contentClass: 'ecommerce-application',
    //     breadcrumb: [
    //       {
    //         text: 'Order',
    //       },
    //       {
    //         text: 'Edit',
    //         active: true,
    //       },
    //     ],
    //     resource: 'normal',
    //     action: 'manage',
    //   },
    // },

    {
      path: '/customer-orders/order-delivery',
      name: 'customer-orders-delivery',
      component: () => import('@/views/customer-orders/check-delivery/order-delivery.vue'),
      meta: {
        pageTitle: 'Delivey',
        contentClass: 'ecommerce-application',
        breadcrumb: [
          {
            text: 'Order',
          },
          {
            text: 'Delivey',
            active: true,
          },
        ],
        resource: 'normal',
        action: 'manage',
      },
    },
    //ลูกค้า shipping
    {
      path: '/customer-shipping/status',
      name: 'customer-shipping-status',
      component: () => import('@/views/customer-shipping/check-status/status.vue'),
      meta: {
        pageTitle: 'เช็คสถานะ',
        contentClass: 'ecommerce-application',
        breadcrumb: [
          {
            text: 'เช็คสถานะ',
            active: true,
          },
        ],
        resource: 'normal',
        action: 'manage',
      },
    },
    {
      path: '/customer-shipping/inform',
      name: 'customer-shipping-inform',
      component: () => import('@/views/customer-shipping/check-status/inform.vue'),
      meta: {
        pageTitle: 'แจ้งออกของ',
        contentClass: 'ecommerce-application',
        breadcrumb: [
          {
            text: 'แจ้งออกของ',
            active: true,
          },
        ],
        resource: 'normal',
        action: 'manage',
      },
    },
    {
      path: '/customer-shipping/view-request',
      name: 'customer-shipping-request',
      component: () => import('@/views/customer-shipping/check-status/view-request.vue'),
      meta: {
        pageTitle: 'รายละเอียดแจ้งออกของ',
        contentClass: 'ecommerce-application',
        breadcrumb: [
          {
            text: 'รายละเอียดแจ้งออกของ',
            active: false,
            to: 'customer-shipping-status',
            tab: 1
          },
          {
            text: requestId,
            active: true,
          },
        ],
        resource: 'normal',
        action: 'manage',
      },
    },
    // {
    //   path: '/customer-shipping/delivery',
    //   name: 'customer-shipping-delivery',
    //   component: () => import('@/views/customer-shipping/check-delivery/delivery.vue'),
    //   meta: {
    //     pageTitle: 'บิลค่าขนส่ง',
    //     contentClass: 'ecommerce-application',
    //     breadcrumb: [
    //       {
    //         text: 'บิลค่าขนส่ง',
    //         active: true,
    //       },
    //     ],
    //     resource: 'normal',
    //     action: 'manage',
    //   },
    // },
    {
      path: '/customer-shipping/delivery',
      name: 'customer-shipping-delivery',
      component: () => import('@/views/customer-shipping/check-delivery/delivery-v2.vue'),
      meta: {
        pageTitle: 'บิลค่าขนส่ง',
        contentClass: 'ecommerce-application',
        breadcrumb: [
          {
            text: 'บิลค่าขนส่ง',
            active: true,
          },
        ],
        resource: 'normal',
        action: 'manage',
      },
    },
    {
      path: '/customer-shipping/how-to-order',
      name: 'customer-shipping-howtoorder',
      component: () => import('@/views/customer-shipping/how-to-order/how-to.vue'),
      meta: {
        pageTitle: 'วิธีการสั่งของ',
        contentClass: 'ecommerce-application',
        breadcrumb: [
          {
            text: 'วิธีการสั่งของ',
            active: true,
          },
        ],
        resource: 'normal',
        action: 'manage',
      },
    },

    // การเงิน
    {
      path: '/finance/transfer',
      name: 'finance-transfer',
      component: () => import('@/views/finance/payment/transfer-payment.vue'),
      meta: {
        pageTitle: 'แจ้งชำระเงิน',
        breadcrumb: [
          {
            text: 'แจ้งชำระเงิน',
            active: true,
          },
        ],
        resource: 'high1',
        action: 'manage',
      },
    },
    // china payment - flashpay
    {
      path: '/finance/china-payment',
      name: 'flash-china-payment',
      component: () => import('@/views/finance/payment/flashpay-china-payment.vue'),
      meta: {
        pageTitle: 'ฝากจ่าย/โอนเงินจีน',
        breadcrumb: [
          {
            text: 'ฝากจ่าย/โอนเงินจีน',
            active: true,
          },
        ],
        resource: 'high1',
        action: 'manage',
      },
    },
    //new payment
    {
      path: '/finance/flash-payment',
      name: 'flash-payment',
      component: () => import('@/views/finance/payment/flash-payment.vue'),
      meta: {
        pageTitle: 'แจ้งชำระเงิน-ใหม่',
        breadcrumb: [
          {
            text: 'แจ้งชำระเงิน-ใหม่',
            active: true,
          },
        ],
        resource: 'high1',
        action: 'manage',
      },
    },
    //new latest payment
    {
      path: '/finance/payment',
      name: 'flash-payment',
      component: () => import('@/views/finance/payment/new-payment.vue'),
      meta: {
        pageTitle: 'แจ้งชำระเงิน',
        breadcrumb: [
          {
            text: 'แจ้งชำระเงิน',
            active: true,
          },
        ],
        resource: 'high1',
        action: 'manage',
      },
    },
    // tranfers yuan
    {
      path: '/finance/payment-transfer-yuan',
      name: 'payment-transfer-yuan',
      component: () => import('@/views/finance/yuan-payment/transfer.vue'),
      meta: {
        pageTitle: 'แจ้งโอนเงินไปจีน',
        breadcrumb: [
          {
            text: 'แจ้งโอนเงินไปจีน',
            active: true,
          },
        ],
        resource: 'high1',
        action: 'manage',
      },
    },
    // [BUG_REPORT ข้อ 2] ตัดเมนูแล้ว — comment route กันเข้าผ่าน URL ตรง (ไม่ลบ)
    /*
    {
      path: '/finance/refund-request',
      name: 'finance-refund',
      component: () => import('@/views/finance/refundRequest/refund.vue'),
      meta: {
        pageTitle: 'แจ้งร้านจีนคืนเงิน',
        breadcrumb: [
          {
            text: 'แจ้งร้านจีนคืนเงิน',
            active: true,
          },
        ],
        resource: 'high1',
        action: 'manage',
      },
    },
    {
      path: '/finance/inform-payment',
      name: 'inform-payment',
      component: () => import('@/views/finance/how-to-payment/how-to.vue'),
      meta: {
        pageTitle: 'วิธีแจ้งชำระเงินจีน',
        breadcrumb: [
          {
            text: 'วิธีแจ้งชำระเงินจีน',
            active: true,
          },
        ],
        resource: 'high1',
        action: 'manage',
      },
    },
    */
    {
      path: '/finance/balance',
      name: 'finance-balance',
      component: () => import('@/views/finance/balance/balance.vue'),
      meta: {
        pageTitle: 'รายการ Balance',
        breadcrumb: [
          {
            text: 'รายการ Balance',
            active: true,
          },
        ],
        resource: 'normal',
        action: 'manage',
      },
    },
    {
      path: '/finance/yaun-payment',
      name: 'finance-yaun-payment',
      component: () => import('@/views/finance/balance/yuan-payment.vue'),
      meta: {
        pageTitle: 'ข้อมูลการจ่ายเงินหยวน',
        breadcrumb: [
          {
            text: 'ข้อมูลการจ่ายเงินหยวน',
            active: true,
          },
        ],
        resource: 'normal',
        action: 'manage',
      },
    },
    // [BUG_REPORT ข้อ 2] ตัดเมนูแล้ว — comment route กันเข้าผ่าน URL ตรง (ไม่ลบ)
    /*
    {
      path: '/finance/withdraw',
      name: 'finance-withdraw',
      component: () => import('@/views/finance/withdraw/withdraw.vue'),
      meta: {
        pageTitle: 'ถอนเงิน',
        breadcrumb: [
          {
            text: 'ถอนเงิน',
            active: true,
          },
        ],
        resource: 'high2',
        action: 'manage',
      },
    },
    */

    // แต้มสะสม
    // [BUG_REPORT ข้อ 2] ตัดเมนูแล้ว — comment route กันเข้าผ่าน URL ตรง (ไม่ลบ)
    /*
    {
      path: '/rewards/point-balance',
      name: 'point-balance',
      component: () => import('@/views/rewards/point-balance.vue'),
      meta: {
        pageTitle: 'แต้มสะสม',
        breadcrumb: [
          {
            text: 'แต้มสะสม',
            active: true,
          },
        ],
        resource: 'normal',
        action: 'manage',
      },
    },
    {
      path: '/rewards/exchange-point',
      name: 'exchange-point',
      component: () => import('@/views/rewards/exchange-point.vue'),
      meta: {
        pageTitle: 'แลกแต้ม',
        breadcrumb: [
          {
            text: 'แลกแต้ม',
            active: true,
          },
        ],
        resource: 'normal',
        action: 'manage',
      },
    },
    */

    //เชื่อมต่อ
    {
      path: '/connect/line',
      name: 'connect-line',
      component: () => import('@/views/connect/line-notify.vue'),
      meta: {
        pageTitle: 'เชื่อมต่อ',
        breadcrumb: [
          {
            text: 'เชื่อมต่อ',
            active: true,
          },
        ],
        resource: 'normal',
        action: 'manage',
      },
    },
    {
      path: '/linenotify/callback',
      name: 'line-callback',
      component: () => import('@/views/connect/line-callback.vue'),
      meta: {
        pageTitle: 'กำลังเชื่อมต่อ',
        breadcrumb: [
          {
            text: 'กำลังเชื่อมต่อ',
            active: true,
          },
        ],
        resource: 'normal',
        action: 'manage',
      },
    },
    {
      path: '/connect',
      name: 'connect',
      component: () => import('@/views/connect/telegram-notify.vue'),
      meta: {
        pageTitle: 'เชื่อมต่อ',
        breadcrumb: [
          {
            text: 'เชื่อมต่อ',
            active: true,
          },
        ],
        resource: 'normal',
        action: 'manage',
      },
    },

    //ข้อมูลส่วนตัว
    // [BUG_REPORT ข้อ 2] ตัดเมนูแล้ว — comment route กันเข้าผ่าน URL ตรง (ไม่ลบ)
    /*
    {
      path: '/me/coupon',
      name: 'me-coupon',
      component: () => import('@/views/personal-information/coupon/coupon.vue'),
      meta: {
        pageTitle: 'คูปองของฉัน',
        breadcrumb: [
          {
            text: 'คูปองของฉัน',
            active: true,
          },
        ],
        resource: 'normal',
        action: 'manage',
      },
    },
    {
      path: '/free/coupon',
      name: 'free-coupon',
      component: () => import('@/views/personal-information/coupon/free-coupon.vue'),
      meta: {
        pageTitle: 'คูปองฟรี',
        breadcrumb: [
          {
            text: 'คูปองฟรี',
            active: true,
          },
        ],
        resource: 'normal',
        action: 'manage',
      },
    },
    */
    {
      path: '/me/address',
      name: 'me-address',
      component: () => import('@/views/personal-information/delivery/address.vue'),
      meta: {
        pageTitle: 'ที่อยู่จัดส่ง',
        breadcrumb: [
          {
            text: 'ที่อยู่จัดส่ง',
            active: true,
          },
        ],
        resource: 'normal',
        action: 'manage',
      },
    },
    {
      path: '/me/information',
      name: 'me-information',
      component: () => import('@/views/personal-information/information/information.vue'),
      meta: {
        pageTitle: 'ข้อมูลทั่วไป',
        breadcrumb: [
          {
            text: 'ข้อมูลทั่วไป',
            active: true,
          },
        ],
        resource: 'normal',
        action: 'manage',
      },
    },
    {
      path: '/company/information',
      name: 'company-information',
      component: () => import('@/views/personal-information/information/company.vue'),
      meta: {
        pageTitle: 'ข้อมูลบริษัท',
        breadcrumb: [
          {
            text: 'ข้อมูลทั่วไป',
            active: false,
            to: 'me-information',
          },
          {
            text: 'ข้อมูลบริษัท',
            active: true,
          },
        ],
        resource: 'normal',
        action: 'manage',
      },
    },
    // [BUG_REPORT ข้อ 2] ตัดเมนูแล้ว — comment route กันเข้าผ่าน URL ตรง (ไม่ลบ)
    /*
    {
      path: '/me/problem',
      name: 'me-problem',
      component: () => import('@/views/personal-information/problem-feedback/problem.vue'),
      meta: {
        pageTitle: 'แจ้งปัญหา/ข้อเสนอแนะ',
        breadcrumb: [
          {
            text: 'แจ้งปัญหา/ข้อเสนอแนะ',
            active: true,
          },
        ],
        resource: 'normal',
        action: 'manage',
      },
    },
    */
    {
      path: '/me/update-password',
      name: 'me-update-password',
      component: () => import('@/views/personal-information/information/update-password.vue'),
      meta: {
        pageTitle: 'แก้ไขรหัสผ่าน',
        breadcrumb: [
          {
            text: 'แก้ไขรหัสผ่าน',
            active: true,
          },
        ],
        resource: 'normal',
        action: 'manage',
      },
    },
    {
      path: '/me/forgot-password',
      name: 'me-forgot-password',
      component: () => import('@/views/personal-information/information/forgot-password.vue'),
      meta: {
        pageTitle: 'forgot-password',
        breadcrumb: [
          {
            text: 'me-information',
          },
          {
            text: 'forgot-password',
            active: true,
          },
        ],
        resource: 'Auth',
        redirectIfLoggedIn: true,
      },
    },
    
    //admin uplaod excel
    {
      path: '/upload/excel',
      name: 'admin-upload',
      component: () => import('@/views/upload-excel/upload.vue'),
      meta: {
        pageTitle: 'อัปโหลด',
        breadcrumb: [
          {
            text: 'อัปโหลด',
            active: true,
          },
        ],
        resource: 'TaobaoAdmin',
        action: 'manage',
      },
    },
    {
      path: '/admin/dashboard',
      name: 'admin-dashboard',
      component: () => import('@/views/admin/dashboard/dashboard.vue'),
      meta: {
        pageTitle: 'แดชบอร์ด',
        breadcrumb: [
          {
            text: 'แดชบอร์ด',
            active: true,
          },
        ],
        resource: 'TaobaoAdmin',
        action: 'manage',
      },
    },

    //file test src\views\test.vue
    {
      path: '/taobao2you/test',
      name: 'taobao2you-test',
      component: () => import('@/views/test.vue'),
      meta: {
        pageTitle: 'test',
        breadcrumb: [
          {
            text: 'test',
            active: true,
          },
        ],
        resource: 'normal',
        action: 'manage',
      },
    },
  ]